package link.erpango.quip.data.remote.ktor

/**
 * Clon de TokenFeature de moko-network para resolver los problemas surgidos al actualizar la librería de ktor desde la 1.6.7 a la versión 2.0.3
 */

import io.ktor.client.HttpClient
import io.ktor.client.plugins.*
import io.ktor.client.request.HttpRequestPipeline
import io.ktor.client.request.header
import io.ktor.util.AttributeKey

class TokenFeature private constructor(
    private val tokenHeaderName: String,
    private val tokenProvider: TokenProvider
) {

    class Config {
        var tokenHeaderName: String? = null
        var tokenProvider: TokenProvider? = null
        fun build() = TokenFeature(
            tokenHeaderName ?: throw IllegalArgumentException("HeaderName should be contain"),
            tokenProvider ?: throw IllegalArgumentException("TokenProvider should be contain")
        )
    }

    companion object Feature : HttpClientPlugin<Config, TokenFeature> {
        override val key = AttributeKey<TokenFeature>("TokenFeature")

        override fun prepare(block: Config.() -> Unit) = Config().apply(block).build()

        override fun install(feature: TokenFeature, scope: HttpClient) {
            scope.requestPipeline.intercept(HttpRequestPipeline.State) {
                feature.tokenProvider.getToken()?.apply {
                    context.headers.remove(feature.tokenHeaderName)
                    context.header(feature.tokenHeaderName, this)
                }
            }
        }
    }

    interface TokenProvider {
        suspend fun getToken(): String?
    }
}
